const map = {
	"./KLM.json": [
		2721,
		[
			2721
		]
	],
	"./aeroflot.json": [
		3689,
		[
			3689
		]
	],
	"./airBaltic.json": [
		6906,
		[
			6906
		]
	],
	"./airIndia.json": [
		9426,
		[
			9426
		]
	],
	"./airastana.json": [
		2409,
		[
			2409
		]
	],
	"./airblue.json": [
		8339,
		[
			8339
		]
	],
	"./aircairo.json": [
		5817,
		[
			5817
		]
	],
	"./airchina.json": [
		6090,
		[
			6090
		]
	],
	"./aircompanyArmenia.json": [
		8401,
		[
			8401
		]
	],
	"./airmanas.json": [
		389,
		[
			389
		]
	],
	"./alrosaAirlines.json": [
		6380,
		[
			6380
		]
	],
	"./arianaAfghanAirlines.json": [
		6269,
		[
			6269
		]
	],
	"./asianaAirlines.json": [
		9653,
		[
			9653
		]
	],
	"./auroraAirlines.json": [
		2666,
		[
			2666
		]
	],
	"./aviaTraffic.json": [
		4553,
		[
			4553
		]
	],
	"./azal.json": [
		6415,
		[
			6415
		]
	],
	"./azimuth.json": [
		975,
		[
			975
		]
	],
	"./azurair.json": [
		6479,
		[
			6479
		]
	],
	"./belavia.json": [
		1777,
		[
			1777
		]
	],
	"./centrumAir.json": [
		7139,
		[
			7139
		]
	],
	"./chinaSouthern.json": [
		3436,
		[
			3436
		]
	],
	"./egyptAir.json": [
		7084,
		[
			7084
		]
	],
	"./emiratesAir.json": [
		1059,
		[
			1059
		]
	],
	"./flyaristan.json": [
		5604,
		[
			5604
		]
	],
	"./flydubai.json": [
		2087,
		[
			2087
		]
	],
	"./georgianAirways.json": [
		2033,
		[
			2033
		]
	],
	"./gulfAir.json": [
		1305,
		[
			1305
		]
	],
	"./ikarAir.json": [
		858,
		[
			858
		]
	],
	"./indigoAirlines.json": [
		780,
		[
			780
		]
	],
	"./iraero.json": [
		1743,
		[
			1743
		]
	],
	"./iranAsemanAirlines.json": [
		5275,
		[
			5275
		]
	],
	"./jazeeraAirways.json": [
		703,
		[
			703
		]
	],
	"./kamAir.json": [
		856,
		[
			856
		]
	],
	"./kishAir.json": [
		9434,
		[
			9434
		]
	],
	"./koreanAir.json": [
		6875,
		[
			6875
		]
	],
	"./kuwaitAirways.json": [
		8336,
		[
			8336
		]
	],
	"./lufthansaAir.json": [
		4845,
		[
			4845
		]
	],
	"./mahanAir.json": [
		3346,
		[
			3346
		]
	],
	"./middleEastAirlines.json": [
		70,
		[
			70
		]
	],
	"./myWayAirlines.json": [
		9745,
		[
			9745
		]
	],
	"./nordwindAir.json": [
		658,
		[
			658
		]
	],
	"./omanAir.json": [
		4402,
		[
			4402
		]
	],
	"./pegasusAir.json": [
		8973,
		[
			8973
		]
	],
	"./pia.json": [
		1349,
		[
			1349
		]
	],
	"./pobeda.json": [
		9806,
		[
			9806
		]
	],
	"./qanotsharq.json": [
		8815,
		[
			8815
		]
	],
	"./qatarAirways.json": [
		6418,
		[
			6418
		]
	],
	"./qeshmAir.json": [
		266,
		[
			7885
		]
	],
	"./rossiyaAirlines.json": [
		6994,
		[
			6994
		]
	],
	"./s7.json": [
		9695,
		[
			9695
		]
	],
	"./salamAir.json": [
		4143,
		[
			4143
		]
	],
	"./saudiaAirlines.json": [
		8429,
		[
			8429
		]
	],
	"./sereneAir.json": [
		223,
		[
			223
		]
	],
	"./silkAvia.json": [
		9729,
		[
			9729
		]
	],
	"./somonAir.json": [
		2781,
		[
			2781
		]
	],
	"./spicejet.json": [
		2716,
		[
			2716
		]
	],
	"./syrianAir.json": [
		4749,
		[
			4749
		]
	],
	"./tajikAir.json": [
		4424,
		[
			4424
		]
	],
	"./turkishAirlines.json": [
		3380,
		[
			3380
		]
	],
	"./turkmenistanAirlines.json": [
		8533,
		[
			8533
		]
	],
	"./uralAirlines.json": [
		5948,
		[
			5948
		]
	],
	"./uzairways.json": [
		4954,
		[
			4954
		]
	],
	"./vistara.json": [
		315,
		[
			315
		]
	],
	"./wizzAir.json": [
		6247,
		[
			6247
		]
	],
	"./yakutiaAirlines.json": [
		5088,
		[
			5088
		]
	],
	"./yamalAirlines.json": [
		1028,
		[
			1028
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3872;
module.exports = webpackAsyncContext;